type TFootProps = {
  children: React.ReactNode;
};

export const TFoot = ({ children }: TFootProps) => {
  return <>{children}</>;
};
